import MetaMaskOnboarding from '@metamask/onboarding';
import React from 'react';
import Web3 from 'web3';
import numeral from 'numeral';

import { chainMap, explorers, fetchy } from './tools/ChainTools.js'

import { BigNumber } from '@ethersproject/bignumber';



import { TheNest, Nest } from './Nest.js'

//import { nestABI } from './nestABI.js';

import './App.scss';

import logo from './imgs/Moon_Wasp_Logo.svg';
import moonwasp from './imgs/MoonWasp.svg';
import hivelogo from './imgs/MoonWaspHive.svg';
import FlyingWasp from './flyingwasp.js';


const nestABI = [{"type":"constructor","stateMutability":"nonpayable","inputs":[]},{"type":"event","name":"Approval","inputs":[{"type":"address","name":"owner","internalType":"address","indexed":true},{"type":"address","name":"spender","internalType":"address","indexed":true},{"type":"uint256","name":"value","internalType":"uint256","indexed":false}],"anonymous":false},{"type":"event","name":"OwnershipTransferred","inputs":[{"type":"address","name":"previousOwner","internalType":"address","indexed":true},{"type":"address","name":"newOwner","internalType":"address","indexed":true}],"anonymous":false},{"type":"event","name":"Transfer","inputs":[{"type":"address","name":"from","internalType":"address","indexed":true},{"type":"address","name":"to","internalType":"address","indexed":true},{"type":"uint256","name":"value","internalType":"uint256","indexed":false}],"anonymous":false},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"MAX_NEST_AMT","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"SECONDS_IN_A_DAY","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"accumulated","inputs":[{"type":"address","name":"account","internalType":"address"}]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"allowance","inputs":[{"type":"address","name":"owner","internalType":"address"},{"type":"address","name":"spender","internalType":"address"}]},{"type":"function","stateMutability":"nonpayable","outputs":[{"type":"bool","name":"","internalType":"bool"}],"name":"approve","inputs":[{"type":"address","name":"spender","internalType":"address"},{"type":"uint256","name":"amount","internalType":"uint256"}]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"balanceOf","inputs":[{"type":"address","name":"account","internalType":"address"}]},{"type":"function","stateMutability":"nonpayable","outputs":[{"type":"bool","name":"","internalType":"bool"}],"name":"burn","inputs":[{"type":"uint256","name":"burnQuantity","internalType":"uint256"}]},{"type":"function","stateMutability":"payable","outputs":[],"name":"claim","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"costToClaim","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint8","name":"","internalType":"uint8"}],"name":"decimals","inputs":[]},{"type":"function","stateMutability":"nonpayable","outputs":[{"type":"bool","name":"","internalType":"bool"}],"name":"decreaseAllowance","inputs":[{"type":"address","name":"spender","internalType":"address"},{"type":"uint256","name":"subtractedValue","internalType":"uint256"}]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"emissionPerMinerPerDay","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"getNESTPrice","inputs":[]},{"type":"function","stateMutability":"nonpayable","outputs":[{"type":"bool","name":"","internalType":"bool"}],"name":"increaseAllowance","inputs":[{"type":"address","name":"spender","internalType":"address"},{"type":"uint256","name":"addedValue","internalType":"uint256"}]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"lastClaim","inputs":[{"type":"address","name":"account","internalType":"address"}]},{"type":"function","stateMutability":"payable","outputs":[],"name":"mintInitialNEST","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"string","name":"","internalType":"string"}],"name":"name","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"address","name":"","internalType":"address"}],"name":"owner","inputs":[]},{"type":"function","stateMutability":"nonpayable","outputs":[],"name":"renounceOwnership","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"string","name":"","internalType":"string"}],"name":"symbol","inputs":[]},{"type":"function","stateMutability":"view","outputs":[{"type":"uint256","name":"","internalType":"uint256"}],"name":"totalSupply","inputs":[]},{"type":"function","stateMutability":"nonpayable","outputs":[{"type":"bool","name":"","internalType":"bool"}],"name":"transfer","inputs":[{"type":"address","name":"recipient","internalType":"address"},{"type":"uint256","name":"amount","internalType":"uint256"}]},{"type":"function","stateMutability":"nonpayable","outputs":[{"type":"bool","name":"","internalType":"bool"}],"name":"transferFrom","inputs":[{"type":"address","name":"sender","internalType":"address"},{"type":"address","name":"recipient","internalType":"address"},{"type":"uint256","name":"amount","internalType":"uint256"}]},{"type":"function","stateMutability":"nonpayable","outputs":[],"name":"transferOwnership","inputs":[{"type":"address","name":"newOwner","internalType":"address"}]},{"type":"function","stateMutability":"nonpayable","outputs":[],"name":"withdraw","inputs":[]}]
const ADDY_WASP = "0xd4306991f8a5CEF2d2bCB3262224dEd11BD18baD"
const ADDY_NEST = "0x3a072ca233608629a6447e51626925D887661233" 
function App() {
  
  // state for managing whether a transaction is pending
  const [isPending, setIsPending] = React.useState(false);

  // --------- -----------%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%-----
  // --------- -----------%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%-----
  // --------- -----------%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%-----
  // Connecting to Metamask
  // --------- -----------%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%-----
  const [connected, setConnected] = React.useState(false)
  const [accounts, setAccounts] = React.useState([]);
  const [mmBtnText, setMMBtnText] = React.useState("Connect");


  // attached to the accountsChanged event listener
  // triggered once manually via connectMM
  function handleNewAccounts(newAccounts) {
    setAccounts(newAccounts);
  }

  // attached to the chainChanged event listener
  // triggered once manually via main hook
  // calls letItRip if the proper chain is selected
  function handleChainChange(chainId) {
    
     if (window.ethereum.chainId === "0x64") {
        letItRip();

      } else {
        alert("please switch to xDAI")
      }
  }

  // when triggered, connectMM requests the user connects to the dApp
  // if the user is already connected, or after the user connects,
  // connectMM sets the accounts state to the user's connected accounts,
  // and sets the connected state to true
  const connectMM = () => {
      if (MetaMaskOnboarding.isMetaMaskInstalled()) {
        window.ethereum
          .request({ method: 'eth_requestAccounts' })
          .then((newAccounts) => {
            handleNewAccounts(newAccounts)
            setConnected(true)})
      } 
  }

  // once the user is connected, add the accountsChanged event listener 
  React.useEffect(() => {
    if (connected) {
      window.ethereum.on('accountsChanged', handleNewAccounts);
      return () => {
        window.ethereum.on('accountsChanged', handleNewAccounts);
      };
    }
  }, [connected]);


  // once the user is connected, add the chainChanged event listener
  React.useEffect(() => {
    if (connected) {
      console.log(window.ethereum.chainId)
      window.ethereum.on('chainChanged', handleChainChange);
      return () => {
        window.ethereum.on('chainChanged', handleChainChange);
      }
    }
  }, [connected])
  
  // --------- -------------------------------------------------------------------------------
  // MAIN HOOK -------------------------------------------------------------------------------
  // --------- -------------------------------------------------------------------------------

  // if a user is connected with at least one account,
  // trigger the handleChainChange function
  React.useEffect( () => {
    if (connected) {
        if (accounts.length > 0) {
          handleChainChange(window.ethereum.chainId)  
        }
      }
  }, [connected])
  // --------- -------------------------------------------------------------------------------

  // -- end of connecting to metamask
  // --------- -----------%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%-----

  // state indicating whether the user found the nest manually
  const [nest__IsOpen, setNest__IsOpen] = React.useState(false);

  // state storing the balance of NEST for the given user - 0 by default.
  const [nestBalance, setNestBalance] = React.useState(0);

  // state storing the accumulated amt of NEST for the given user - 0 by default.
  const [nestAccum, setNestAccum] = React.useState(0);

  const [nestPrice, setNestPrice] = React.useState(0);

  const [totalNESTSupply, setTotalNestSupply] = React.useState(0);

  // create a web3 instance and load up the NEST abi
  var web3 = new Web3(Web3.givenProvider || 'http://localhost:8545');
  const nestContract = new web3.eth.Contract(nestABI, ADDY_NEST);
  const nest = new Nest(nestContract, ADDY_NEST)
  // onClick method, enters the nest
  const enterTheNest = () => {
    setNest__IsOpen(true);  
  }

  // state indicating if the user has successfully entered the key and clicked the wasp
  const [nestLvl, setNestLvl] = React.useState(1);

  
  const onboardMM = () => {
      
      // if the user has metamask installed
      if (MetaMaskOnboarding.isMetaMaskInstalled()) {
        // request connection to our dApp
        if (accounts.length > 0) {
          let walletAddress = window.ethereum.selectedAddress;
          if (nestBalance == 0) {
            nest.goMintInitialNest()         
          } else {
            nest.goClaimNest(nestAccum)
          }
        } else {
          connectMM()
        }
      }   
    }




  const checkAccumulated = () => {
    nestContract.methods.accumulated(window.ethereum.selectedAddress).call({}, 
          (error, balance) => {
            setNestAccum(balance);
            setMMBtnText("Claim "+ numeral(balance / 10 ** 18).format("0.0000") + " NEST");
          })
  }

  const getNESTPrice__js = () => {
    nestContract.methods.getNESTPrice().call({}, (error, nestPrice) => {
      setNestPrice(nestPrice);
    })
  }

  const getTotalNestSupply = () => {
    nestContract.methods.totalSupply().call({}, (error, supply) => {
      setTotalNestSupply(supply);
    })
  }



  
const letItRip = () => {
  nest.getBalance((res) => {handleBalanceResponse(res)});
}

const handleBalanceResponse = (bal) => {
  setNestBalance(bal)
  if ( bal > 0 ) {
    buildLevel2();
    getNESTPrice__js();
    getTotalNestSupply();
  } else {
    setMMBtnText("join the nest");
    getNESTPrice__js();
    getTotalNestSupply();
  }
}
        
 const [waspHolders, setWaspHolders] = React.useState([])
 const [nestHolders, setNestHolders] = React.useState([])

  const buildLevel2 = () => {
    
    setNestLvl(2);
    checkAccumulated();

    fetchy(ADDY_WASP, explorers["xDai"], (data) => {
      let cleanData = data.result
      cleanData.forEach(row => {
      
          delete Object.assign(row, {["waspBal"]: row["value"] })["value"];
        
      })
      setWaspHolders(cleanData)
      
    })
    fetchy(ADDY_NEST, explorers["xDai"], (data) => {
      let cleanData = data.result
      cleanData.forEach(row => {
      
          delete Object.assign(row, {["nestBal"]: row["value"] })["value"];
        
      })
      setNestHolders(cleanData)
      
    })
  }


  return (
    <div className="App">
      <header className={"App-header "+ "Nest__isOpen--" + nest__IsOpen}>
        <img src={logo} className="App-logo" alt="logo" />
      
        <span className={"onlymain " + "Nest__isOpen--" + nest__IsOpen}>MOON</span>
        <span className="spanwasp">WASP</span>
        <span className={"onlynest " + "Nest__isOpen--" + nest__IsOpen}>NEST</span>
        <a href="https://honeyswap.org" target="blank">BUY MOONWASP</a>
      </header>
      <div className={"App-body " + "Nest__isOpen--" + nest__IsOpen}>
        <img src={moonwasp} className="moonwasp" alt="moonwasp" />


        <h1>The xDai chain is abuzz with MOON<span>WASP</span></h1>
        <p className="focusp">MOONWASP is the first xDai exclusive <span className="strike">shitcoin</span> community coin!</p>
        <p className="flushp"><em>(idk.. probably not; but we were close, right?)</em></p>
        <div className="WASP__section">
          <h2><span className="wasph2">MOONWASP</span><span> STATS</span></h2>
          
          <p>Total Supply: <strong>833,833,833</strong></p>
          <p>Maximum Transaction Size: <strong>2,333,333</strong></p>
          <p>Reflection per Transaction: <strong>2%</strong></p>
          <p>Contract Address: {ADDY_WASP}</p>
          <p>(<a href="https://blockscout.com/poa/xdai/address/0xd4306991f8a5CEF2d2bCB3262224dEd11BD18baD/contracts" target="blank"> Review the Contract on Blockscout </a>)</p>
        </div>

        
        <div className="WASP__section">
          <h2><span className="wasph2">MOONWASP</span><span> STARMAP</span></h2>
          <p>End of July 2021: All secrets will be revealed.</p>
          <p>End of August 2021: So much stuff.. like dude this is gonna be wild.</p>
          <p>End of Autumn 2021: ALL WASPS EXCEPT THE QUEEN DIE EVERY WINTER</p>
        </div>
        <div className="WASP__section">
          <h2><span className="wasph2">?? WTF ARE </span><span>SECRETS ??</span></h2>
          <p>Now, that's a fucking secret...</p>
          <p>Clues are everywhere.</p>
        </div>  
      </div>
      <div id="x833" className="x833" onClick={enterTheNest}>Enter the Nest</div>
      
      <TheNest 
        nestState={nest__IsOpen} 
        nestLvl={nestLvl} 
        nestLogo={hivelogo} 
        nestBalance={nestBalance} 
        nestAccum={nestAccum} 
        nestPrice={nestPrice} 
        onboardMM={onboardMM} 
        mmBtnText={mmBtnText} 
        totalNESTSupply={totalNESTSupply}
        nestHolders={nestHolders}
        waspHolders={waspHolders}/>
    </div>

  );
}

export default App;
